import Reviews from "../../layouts/Reviews";
import ToiletReviewTable from "../../components/reviews/ToiletReviewTable";
export default function ToiletReviews() {

    const rightContent = (
        <div>
            <ToiletReviewTable/>
        </div>
    )
    return (
        <div className="toilet-reviews-page">
            <Reviews rightContent={rightContent}/>
        </div>
    )
}
